var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('div',{staticClass:"page-not-found-page w-100 p-0 m-0"},[_c('h1',[_vm._v("Page Not Found")])])])}
var staticRenderFns = []

export { render, staticRenderFns }